"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function ContainerDatabase(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "#616DDC",
    clipPath: "url(#prefix__container-database__clip0_13467_55)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.236 7.82V3.344C14.236 1.468 11.22 0 7.368 0 3.516 0 .5 1.468.5 3.344v9.328C.5 14.548 3.516 16 7.368 16c2.304 0 4.304-.524 5.544-1.344a4.217 4.217 0 001.324-6.852v.016zM12.392 14a3.42 3.42 0 01-4.552-3.044v-.176A3.416 3.416 0 1112.392 14zM7.368.844c2.856 0 6.036 1.036 6.064 2.528-.04 1.484-3.2 2.52-6.064 2.52S1.344 4.856 1.3 3.372C1.332 1.88 4.5.844 7.368.844zM1.3 4.936c1.144 1.052 3.408 1.756 6.068 1.756 2.66 0 4.924-.692 6.068-1.756V7.2a4.18 4.18 0 00-2.184-.612 4.228 4.228 0 00-4.172 3.6C4.292 10.108 1.3 9.084 1.3 7.64V4.936zm6.068 10.232c-2.868 0-6.068-1.044-6.068-2.54V9.224c1.096 1.008 3.22 1.696 5.74 1.752a4.224 4.224 0 003.092 3.884c-.907.204-1.834.307-2.764.308z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.452 9.792c.034-.08.077-.157.128-.228a.916.916 0 01.78-.364.876.876 0 01.472.124.713.713 0 01.18.136.892.892 0 01.256.54.37.37 0 010 .116h.984a1.966 1.966 0 00-.124-.648 1.637 1.637 0 00-.424-.62l-.024-.02a1.9 1.9 0 00-1.328-.464A1.976 1.976 0 009.804 9a2.172 2.172 0 00-.496 1.028c-.048.22-.07.446-.068.672v.16c-.03.616.175 1.22.572 1.692a2 2 0 001.56.648 2 2 0 00.936-.22c.278-.134.516-.34.688-.596.165-.235.26-.513.272-.8h-.984a.8.8 0 01-.276.564.944.944 0 01-.648.228.916.916 0 01-.8-.372 1.891 1.891 0 01-.272-1.128v-.18c-.01-.31.045-.618.164-.904z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__container-database__clip0_13467_55"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

ContainerDatabase.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
ContainerDatabase.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = ContainerDatabase;
exports["default"] = _default;